<template>
  <v-navigation-drawer
    id="app-drawer"
    app
    dark
    floating
    persistent
    mobile-break-point="960"
    width="260"
    color="#ffffff"
    :expand-on-hover="true"
    :mini-variant.sync="mini"
  >
    <v-layout tag="v-list" column>
      <asset-drawer></asset-drawer>
      <!--        MENU-->
      <v-list :shaped="shaped" :nav="nav">
        <v-list-item-group v-model="item" color="primary pink--text">
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            :to="item.link"
            v-show="item.value"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" color="#625f6e"></v-icon>
            </v-list-item-icon>
            <v-list-item-content style="color: #625f6e;">
              <v-list-item-title
                v-html="item.title"
                class="subtitle-2 font-weight-regular"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import eventBus from "../../../main";
import jwtDecode from "jwt-decode";
//import store from "../../../store";
import AssetDrawer from "../geral/AssetDrawer";
import store from "../../../store";

export default {
  components: { AssetDrawer },
  data: () => ({
    shaped: false,
    nav: false,
    avatar: true,
    mini: false,
    drawer: false,
    item: 0,
    sso: null,

    security: {
      icon: "mdi-shield-lock",
      title: "Segurança",
      link: "/help/center",
      value: true
    },
    wallet: {
      icon: "mdi-wallet",
      title: "Carteira",
      value: true
    },

    items: [
      {
        comment: "@ENTERPRISE",
        icon: "mdi-tablet-dashboard",
        title: "Resumo",
        link: "/enterprise",
        value:
          store.getters.getDrawerEnterprise === store.getters.getRefusionUnunion
      },
      {
        comment: "@INVOICES",
        icon: "mdi-shopping",
        title: "Produtos",
        link: "/product/category",
        value:
          store.getters.getDrawerEnterprise === store.getters.getRefusionUnunion
      },
      {
        comment: "@ENTERPRISE",
        icon: "mdi-format-list-text",
        title: "Transações",
        link: "/transactions",
        value:
          store.getters.getDrawerEnterprise === store.getters.getRefusionUnunion
      },
      {
        comment: "@INVOICES",
        icon: "mdi-receipt",
        title: "Facturas",
        link: "/invoices",
        value:
          store.getters.getDrawerEnterprise === store.getters.getRefusionUnunion
      },
      {
        comment: "@INVOICES",
        icon: "mdi-chart-bar-stacked",
        title: "Relatórios",
        link: "/report",
        value:
          store.getters.getDrawerEnterprise === store.getters.getRefusionUnunion
      },

      // {
      //   comment: "@ENTERPRISE",
      //   icon: "mdi-wallet",
      //   title: "Carteira",
      //   link: "/w/wallet",
      //   value:
      //     store.getters.getDrawerEnterprise === store.getters.getRefusionUnunion
      // },
      {
        comment: "@ENTERPRISE",
        icon: "mdi-account",
        title: "Perfil",
        link: "/e/profile",
        value:
          store.getters.getDrawerEnterprise === store.getters.getRefusionUnunion
      },
      {
        comment: "@ENTERPRISE",
        icon: "mdi-cog-outline",
        title: "Definições",
        link: "/a/account/config",
        value:
          store.getters.getDrawerEnterprise === store.getters.getRefusionUnunion
      }
    ]
  }),
  methods: {
    openRemoveCard() {
      eventBus.$emit("openSecurity", true); // emit the event to the bus
    },
    openWallet() {
      eventBus.$emit("openWallet", true); // emit the event to the bus
    }
  },
  beforeCreate() {
    const userToken = localStorage.getItem("token");
    const decode = jwtDecode(userToken);
    let startWith = decode.Pub;
    store.dispatch("setDrawerEnterprise", startWith.substr(5, 6));
  }
};
</script>

<style lang="scss">
.arrangeBottom {
  bottom: 5px;
  width: 100%;
  position: fixed;
}

.arrangeWaalet {
  margin-top: -16px;
}
/*color="blue-grey darken-4"*/
/*#app-drawer {*/
/*  .v-list__tile {*/
/*    border-radius: 4px;*/

/*    &--buy {*/
/*      margin-top: auto;*/
/*      margin-bottom: 17px;*/
/*    }*/
/*  }*/
/*}*/
</style>
